import passIcon from '@/assets/images/pass.svg';
import limiteInicialIcon from '@/assets/images/limite-inicial.svg';
import primeIcon from '@/assets/images/prime.svg';
import bpoIcon from '@/assets/images/bpo.svg';
import acquisitionIcon from '@/assets/images/aquisicao-de-cotacao.svg';

export const iconsDictionary = {
    welcome: {
        icon: 'fas fa-star',
        style: {
            color: '#FDC30C',
            border: 'solid 2px #FDC30C'
        }
    },
    acquisition_plan: {
        icon: 'fas fa-link',
        style: {
            color: '#007BFF',
            border: 'solid 2px #007BFF'
        }
    },
    limit_initial: {
        svgPath: limiteInicialIcon
    },
    acquisition_quotation_pass: {
        svgPath: passIcon
    },
    acquisition_quotation_pro: {
        icon: 'fas fa-hands-helping'
    },
    acquisition_quotation: {
        svgPath: acquisitionIcon,
        style: {
            padding: '2px'
        }
    },
    acquisition_quotation_prime: {
        svgPath: primeIcon,
        style: {
            padding: '2px'
        }
    },
    acquisition_quotation_bpo: {
        svgPath: bpoIcon
    },
    acquisition_quotation_enterprise: {
        icon: 'fas fa-handshake'
    },
    acquisition_contact_pro: {
        icon: 'fas fa-award'
    },
    acquisition_contact_quali: {
        icon: 'fas fa-check-circle'
    },
    upgrade: {
        icon: 'fas fa-coins',
        style: {
            color: '#007BFF',
            border: 'solid 2px #007BFF'
        }
    },
    reversal: {
        icon: 'fas fa-undo'
    },
    balance_purchase: {
        icon: 'fas fa-coins'
    },
    acquisition_opportunity: {
        icon: 'fas fa-envelope-open-text'
    },
    acquisition_subscription: {
        icon: 'fas fa-link',
        style: {
            color: '#007BFF',
            border: 'solid 2px #007BFF'
        }
    },
    renovation :{
        icon: 'fas fa-sync',
        style: {
            color: '#007BFF',
            border: 'solid 2px #007BFF'
        }
    }
};
